import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import {
  PdvSession,
  PdvSessionReport,
  PdvTerminalSales,
} from "@models/pdv-session";
import { environment } from "../../environments/environment";

@Injectable({ providedIn: "root" })
export class PdvSessionsService {
  private readonly http = inject(HttpClient);
  list(eventId: number) {
    return this.http.get<PdvSession[]>(
      `${environment.API_BACKEND}/events/${eventId}/pdv_sessions`,
    );
  }
  report(eventId: number, sessionId: number) {
    return this.http.get<PdvSessionReport>(
      `${environment.API_BACKEND}/events/${eventId}/pdv_sessions/${sessionId}/report`,
    );
  }
  terminalSales(eventId: number, page = 1, terminal = "") {
    return this.http.get<PdvTerminalSales>(
      `${environment.API_BACKEND}/events/${eventId}/pdv_sessions/terminal_sales`,
      {
        params: {
          page: String(page),
          per_page: "10",
          ...(terminal === "__unidentified__"
            ? { unidentified_terminal: "true" }
            : terminal
              ? { terminal_id: terminal }
              : {}),
        },
      },
    );
  }
}
